module.exports = __webpack_public_path__ + "img/1512769707.33147265.jpg";